import React from 'react';
import classNames from 'classnames';
import I18n from 'i18n-js';

import { useTimer } from '@lootboy/lib/hooks';
import { ECollectionBannerState } from '@lootboy/lib/slices/cardCollections/types';

import { getTimerLabel } from '~/utils';

import styles from './CollectionStatusPill.module.scss';

interface ICollectionStatusPillProps {
  availableUntil: string;
  collectionState: ECollectionBannerState;
}

const getPillLabel = (
  status: ECollectionBannerState,
  timer: ReturnType<typeof useTimer>,
): string => {
  if (timer.ended && status === ECollectionBannerState.AVAILABLE) {
    return I18n.t('collections_label_timer_ended');
  }

  switch (status) {
    case ECollectionBannerState.AVAILABLE: {
      return getTimerLabel(timer);
    }
    case ECollectionBannerState.UPCOMING: {
      return I18n.t('collections_label_timer_comingsoon');
    }
    case ECollectionBannerState.COMPLETED: {
      return I18n.t('collections_label_timer_submitted');
    }
    case ECollectionBannerState.EXPIRED: {
      return I18n.t('collections_label_timer_ended');
    }
    default: {
      return I18n.t('collections_label_timer_ended');
    }
  }
};

const CollectionStatusPill: React.FC<ICollectionStatusPillProps> = ({
  collectionState,
  availableUntil,
}) => {
  const timer = useTimer(availableUntil);

  return (
    <div className={classNames(styles.container, styles[collectionState])}>
      {getPillLabel(collectionState, timer)}
    </div>
  );
};

export default React.memo(CollectionStatusPill);
